export const BRAND = "New Era";
export const PRODUCT_NAME = "TurboFan Pro";

export const VARIANTS = [
    {
        id: "white-fridge",
        name: "Glacier White",
        edition: "IcePlate Cooling",
        price: 18.99,
        image: "/images/fan-white-fridge.jpeg",
        swatch: "#E8EDF2",
        tag: "Best Seller",
    },
    {
        id: "black-fridge",
        name: "Obsidian Black",
        edition: "IcePlate Cooling",
        price: 18.99,
        image: "/images/fan-black-fridge.jpeg",
        swatch: "#23262B",
    },
    {
        id: "grey-fridge",
        name: "Storm Grey",
        edition: "IcePlate Cooling",
        price: 18.99,
        image: "/images/fan-grey-fridge.jpeg",
        swatch: "#7C5CBF",
    },
    {
        id: "white-highspeed",
        name: "Glacier White",
        edition: "High-Speed",
        price: 18.99,
        image: "/images/fan-white-highspeed.jpeg",
        swatch: "#F4F7FA",
    },
];

export const formatPrice = (n) => `$${n.toFixed(2)}`;

export const ADDONS = [
    { id: "bundle", name: "Fast Shipping + Protection Bundle", price: 4.99, desc: "Priority dispatch, plus instant replacement if lost or damaged" },
];

export const KEY_BENEFITS = [
    "IcePlate cold compress — feels icy in 3 seconds",
    "9m/s airflow with 1–100 precision speed levels",
    "3600mAh battery — up to 12 hours of cooling",
    "Handheld, desk-stand or neck-worn with the included lanyard",
    "Charges over Type-C — cable and lanyard in the box",
];
